import * as React from 'react'
import {Divider} from 'wix-ui-tpa/Divider'
import s from './divider.st.css'

export const DividerExt = props => <Divider {...props} className={s.root} />
